"use strict";

import jQuery from 'jquery';

/**
 * Control zum Sperren des Userinterfaces, während sich Layer beim Laden von Daten befinden.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCMapLoadingIndicator = function( options )
{
	gc.gis.widget.GCWidget.call( this, options );

	var self = this;

	this._target = this.target;	// FIXME: redundant/achtung in abstract-map-control.js
	this._map = options.map;
	this._render();

	this._map.on( gc.gis.map.GCMapEvent.LAYER_LOADING_STARTED, this, function(evt ) {
		self.update();
	});
	this._map.on( gc.gis.map.GCMapEvent.LAYER_LOADING_ENDED, this, function(evt ) {
		self.update();
	});
	this._map.on( gc.gis.map.GCMapEvent.LAYER_LOADING_ERROR, this, function(evt ) {
		self.update();
	});
};
gc.gis.control.GCMapLoadingIndicator.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * @inheritdoc
 */
gc.gis.control.GCMapLoadingIndicator.prototype.init = function()
{
	this._render();
};

/**
 * Rendert das Control.
 *
 * @protected
 * @return {jQuery} Container-Element
 */
gc.gis.control.GCMapLoadingIndicator.prototype._render = function()
{
	if( !this._element )
	{
		if( jQuery(this.target).length === 0 )
		{
			gc.gis.iface.getElement().append( jQuery('<div>', {
				id: this.target.replace(/^#/,'')
			}) );
		}

		this.__element_label = jQuery('<span>', {
			text: 'Lade...'
		});
		this._element = jQuery('<div>', {
			'class': 'gc-map-control-loading-indicator lock-screen'
		});
		this._element.append( jQuery('<div>', {html: this.__element_label}) );

		this._element.hide();
	}
	return this._element;
};

/**
 * Gibt das Container-Element des Controls zurück.
 *
 * @public
 * @return {jQuery}
 */
gc.gis.control.GCMapLoadingIndicator.prototype.getElement = function()
{
	return this._element;
};

/**
 * Zeigt das Element des Controls an.
 *
 * @public
 */
gc.gis.control.GCMapLoadingIndicator.prototype.show = function()
{
	this.getElement().show('fade');
};

/**
 * Versteckt das Element des Controls.
 *
 * @public
 */
gc.gis.control.GCMapLoadingIndicator.prototype.hide = function()
{
	this.getElement().hide('fade');
};

/**
 * Aktualisiert die Anzahl der aktuell im Ladezustand befindlichen Layer.
 *
 * @public
 */
gc.gis.control.GCMapLoadingIndicator.prototype.update = function()
{
    var n = 0;	// n = this._map.getLoadingQueue().length;
    var layers = this._map.getLoadingQueue();
    for (var i = 0; i < layers.length; i++) {
        n += layers[i].loadModal() ? 1 : 0;
    }

	if( n > 0 )
	{
		this.__element_label.text('Lade '+ n +' '+ (n===1?'Element':'Elemente') +'... ');
		if( !this._element.is(':visible') )
		{
			this.show();
		}
	}
	else
	{
		this.hide();
	}
};
